export default {
  "menu.welcome": "Welcome",
  "menu.more-blocks": "More Blocks",
  "menu.home": "Home",
  "menu.admin": "Admin",
  "menu.admin.sub-page": "Sub-Page",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",

  "menu.users": "User Management",
  "menu.users.user-list": "User List",
  "menu.users.top-users-streak": "Top Users Streak",
  "menu.users.user-detail": "User Detail",
  "menu.food-database": "Food Database",
  "menu.food-database.foods": "Foods",
  "menu.food-database.foods.food-list": "Food List",
  "menu.food-database.foods.create-food": "Create Food",
  "menu.food-database.foods.create-packaged-food": "Create Packaged Food (barcode)",
  "menu.food-database.foods.update-food": "Update Food",
  "menu.food-database.foods.food-detail": "Food Detail",
  "menu.food-database.categories": "Categories",
  "menu.food-database.categories.category-list": "Category List",
  "menu.food-database.categories.create-category": "Create Category",
  "menu.food-database.categories.update-category": "Update Category",
  "menu.food-database.brands": "Brands",
  "menu.food-database.brands.brand-list": "Brand List",
  "menu.food-database.brands.create-brand": "Create Brand",
  "menu.food-database.brands.update-brand": "Update Brand",
  "menu.food-database.brands.brand-detail": "Brand Detail",
  "menu.food-database.image-enrichment": "Image Enrichment",
  "menu.food-database.food-tags": "Food Tags",
  "menu.food-database.food-tags.tag-list": "Tag List",
  "menu.food-database.food-tags.create-tag": "Create Tag",
  "menu.food-database.food-tags.update-tag": "Update Tag",
  "menu.food-database.custom-foods": "Custom Foods",
  "menu.food-database.custom-foods.custom-foods-list": "Custom Foods List",
  "menu.food-contributions": "Scan for points",
  "menu.food-contributions.list": "Review Queue",
  "menu.food-contributions.detail": "Contribution Detail",
  "menu.food-contributions.user-locks": "User Locks",
  "menu.food-contributions.violation-stats": "Violation Stats",
  "menu.eatsy-coin": "Eatsy Coin",
  "menu.eatsy-coin.dashboard": "Dashboard",
  "menu.eatsy-coin.wallets": "Wallets",
  "menu.eatsy-coin.ledger": "Ledger",
  "menu.eatsy-coin.redemptions": "Premium Redeems",
  "menu.eatsy-coin.config": "Configuration",
  "menu.system": "System",
  "menu.system.countries": "Countries",
  "menu.system.countries.country-list": "Country List",
  "menu.system.countries.create-country": "Create Country",
  "menu.system.countries.update-country": "Update Country",
  "menu.system.countries.country-detail": "Country Detail",
  "menu.system.languages": "Languages",
  "menu.system.languages.language-list": "Language List",
  "menu.system.languages.create-language": "Create Language",
  "menu.system.languages.update-language": "Update Language",
  "menu.system.languages.language-detail": "Language Detail",
  "menu.system.timezones": "Timezones",
  "menu.system.timezones.timezone-list": "Timezone List",
  "menu.system.timezones.create-timezone": "Create Timezone",
  "menu.system.timezones.update-timezone": "Update Timezone",
  "menu.system.timezones.timezone-detail": "Timezone Detail",
  "menu.system.system-config": "System Configuration",
  "menu.exercise-activity": "Exercise Activity",
  "menu.exercise-activity.categories": "Categories",
  "menu.exercise-activity.categories.category-list": "Category List",
  "menu.exercise-activity.categories.create-category": "Create Category",
  "menu.exercise-activity.categories.update-category": "Update Category",
  "menu.exercise-activity.exercises": "Exercises",
  "menu.exercise-activity.exercises.exercise-list": "Exercise List",
  "menu.exercise-activity.exercises.create-exercise": "Create Exercise",
  "menu.exercise-activity.exercises.update-exercise": "Update Exercise",
  "menu.exercise-activity.difficulty-levels": "Difficulty Levels",
  "menu.exercise-activity.difficulty-levels.difficulty-level-list":
    "Difficulty Level List",
  "menu.exercise-activity.difficulty-levels.create-difficulty-level":
    "Create Difficulty Level",
  "menu.exercise-activity.difficulty-levels.update-difficulty-level":
    "Update Difficulty Level",
  "menu.water-management": "Water Management",
  "menu.water-management.water-types": "Water Types",
  "menu.water-management.water-types.water-type-list": "Water Type List",
  "menu.water-management.water-types.create-water-type": "Create Water Type",
  "menu.water-management.water-types.update-water-type": "Update Water Type",
  "menu.recommendations": "Smart Recommendations",
  "menu.recommendations.dashboard": "Dashboard",
  "menu.recommendations.sessions": "Sessions",
  "menu.recommendations.session-detail": "Session Detail",
  "menu.recommendations.allergen-coverage": "Allergen Coverage",
  "menu.recommendations.allergen-mappings": "Allergen Mappings",
  "menu.recommendations.time-period-options": "Time-Period Options",
  "menu.recommendations.access-control": "Access / Rollout Control",
  "menu.recommendations.algorithm-config": "Algorithm Config",
  "menu.recommendations.catalog-source-registry": "Catalog Source Registry",
  "menu.recommendations.onboarding-catalogues": "Onboarding catalogues",
  "menu.dish-management": "Dish Management",
  "menu.dish-management.dishes": "Dishes",
  "menu.dish-management.dishes.dish-list": "Dish List",
  "menu.dish-management.dishes.create-dish": "Create Dish",
  "menu.dish-management.custom-dishes": "Custom Dishes",
  "menu.dish-management.custom-dishes.custom-dishes-list": "Custom Dishes List",
  "menu.dish-management.dishes.update-dish": "Update Dish",
  "menu.dish-management.dishes.dish-detail": "Dish Detail",
  "menu.dish-management.categories": "Dish Categories",
  "menu.dish-management.categories.category-list": "Category List",
  "menu.dish-management.categories.create-category": "Create Category",
  "menu.dish-management.categories.update-category": "Update Category",
  "menu.dish-management.categories.category-detail": "Category Detail",
  "menu.dish-management.categories.category-dishes-management":
    "Dishes in Category",
  "menu.dish-management.catalogues": "Dish Collections",
  "menu.dish-management.catalogues.catalogue-list": "Collection List",
  "menu.dish-management.catalogues.create-catalogue": "Create Collection",
  "menu.dish-management.catalogues.update-catalogue": "Update Collection",
  "menu.dish-management.catalogues.catalogue-detail": "Collection Detail",
  "menu.dish-management.catalogues.catalogue-dishes-management": "Dishes in Collection",
  "menu.dish-management.reviews": "Dish Reviews",
  "menu.dish-management.reviews.review-list": "Review List",
  "menu.dish-management.reviews.create-review": "Create Review",
  "menu.dish-management.reviews.update-review": "Update Review",
  "menu.conversations": "AI Conversations",
  "menu.conversations.conversation-list": "Conversation List",
  "menu.conversations.conversation-detail": "Conversation Detail",
  "menu.statistics": "Statistics",
  "menu.statistics.overview": "Overview",
  "menu.statistics.revenue": "Revenue",
  "menu.statistics.smart-scale-promotion": "Smart Scale Promotion",
  "menu.statistics.feature-satisfaction": "Suggestion CSAT",
  "menu.scale-management": "Scale Orders",
  "menu.scale-management.orders": "Scale Orders",
  "menu.scale-management.orders.order-list": "Order List",
  "menu.gift-management": "Gift Management",
  "menu.gift-management.campaigns": "Gift Campaigns",
  "menu.gift-management.campaigns.campaign-list": "Campaign List",
  "menu.gift-management.orders": "Gift Orders",
  "menu.gift-management.orders.order-list": "Order List",
  "menu.gift-management.gift-codes": "Activation Codes",
  "menu.tools": "Tools",
  "menu.tools.bmr-tdee-calculator": "BMR & TDEE Calculator",
  "menu.ai-logging": "AI Logging",
  "menu.ai-logging.image-logs": "Food Image Scanning",
  "menu.ai-logging.image-logs.image-logs-list": "Image Logs List",
  "menu.ai-logging.parsing-logs": "Voice/Text Parsing",
  "menu.ai-logging.parsing-logs.parsing-logs-list": "Parsing Logs List",
  "menu.editor": "Graphic Editor",
  "menu.editor.flow": "Flow Editor",
  "menu.editor.mind": "Mind Editor",
  "menu.editor.koni": "Koni Editor",
  "menu.account.center": "Account Center",
  "menu.account.settings": "Account Settings",
  "menu.account.logout": "Logout",
  "menu.shop": "Shop Management",
  "menu.shop.products": "Products",
  "menu.shop.products.product-list": "Product List",
  "menu.shop.products.create-product": "Create Product",
  "menu.shop.products.update-product": "Edit Product",
  "menu.shop.orders": "Orders",
  "menu.shop.orders.order-list": "Order List",
  "menu.shop.shipping-methods": "Shipping Methods",
  "menu.shop.shipping-methods.shipping-method-list": "Shipping Method List",
  "menu.shop.payment-methods": "Payment Methods",
  "menu.shop.payment-methods.payment-method-list": "Payment Method List",
  "menu.shop.settings": "Shop Settings",
};
